/* Propuesta -  registro de propuesta de cambio */

//*react- recursos
  import { useState, useEffect } from "react";
  import { Panel, PanelGroup } from "rsuite";
  import ReactPaginate from "react-paginate";

//*componentes-utiles
  import CargandoSpin from "../../../../componentes/CargandoSpin";
 
//*clases 
  import "../pagination.css";

//*imágenes
  import { BsEnvelope, BsCalendarEvent } from "react-icons/bs";
  import { AiOutlineDoubleLeft, AiOutlineDoubleRight } from "react-icons/ai";

//*archivos & componentes (otros componentes enlazados)
  import PropuestaContenido from "./Propuesta.Contenido"; 

//*api's (servicios y store)
 
  import catalogsServicio from "../../../../api/recursos/catalogs/catalogs.servicio"; 
  import catalogsStore from "../../../../api/recursos/catalogs/catalogs.store"; 
 
  import proposalsServicio from "../../../../api/recursos/proposals/proposals.servicio"; 
  import proposalsStore from "../../../../api/recursos/proposals/proposals.store"; 
 
//*store's

//*datos
  import etiquetasSSC from "../../../../datos/json/etiquetasSSC.json"

//*funciones

//*interfaces
  interface propsPropuesta {
    tokenStore: any;
    menuStore: any;
    quitaErrorPagina:any;
    recargaPaginaSSC:any;
    recargaPaginaSSC_Not:any;
  }

//*componente
  export default function Propuesta(props: propsPropuesta){

    //*api store

      const { guardaGetAllOriginStore, catOrigenesStore,
              guardaGetAllProcessByFrequencyStore, catProcesosStore,
              generaObjErrorCatalogsStore } =  
          catalogsStore((state:any) =>( { 
              guardaGetAllOriginStore: state.guardaGetAllOriginStore,
              catOrigenesStore: state.catOrigenesStore,
              guardaGetAllProcessByFrequencyStore: state.guardaGetAllProcessByFrequencyStore,
              catProcesosStore: state.catProcesosStore,
              generaObjErrorCatalogsStore: state.generaObjErrorCatalogsStore,
              objErrorCatalogsStore: state.objErrorCatalogsStore
      }));

      const { guardaGetSummarybyUserStore,  limpiaPropuestasStore, propuestasStore,
              cambiaPropuestasStore,
              agregaPropuestaNvaStore, propuestaNvaStore, 
              generaObjErrorProposalsStore  } =  
          proposalsStore((state:any) =>( { 
              guardaGetSummarybyUserStore: state.guardaGetSummarybyUserStore,
              limpiaPropuestasStore: state.limpiaPropuestasStore,
              propuestasStore: state.propuestasStore, 
              cambiaPropuestasStore: state.cambiaPropuestasStore,
              agregaPropuestaNvaStore: state.agregaPropuestaNvaStore,
              propuestaNvaStore: state.propuestaNvaStore,
              guardaGetDetailbyUserStore: state.guardaGetDetailbyUserStore,
              propuestaDetallesStore: state.propuestaDetallesStore,
              generaObjErrorProposalsStore: state.generaObjErrorProposalsStore
      }));
      
    //*store's
    
    
    //*datos
      var _ = require('underscore');

    //*constantes y variables
      let eti = etiquetasSSC.Propuesta;
      let x0, x1, x1a, x2, x3 = '';

      //paginación: constante para el manejo de la 
        let data:any  = propuestasStore;  //valores mostradas en para la páginación
        const [currentItems, setCurrentItems] = useState([]);  //elementos mostrados según páginación
        const [pageCount, setPageCount] = useState(0);  //contabilidad de la página
        const [itemOffset, setItemOffset] = useState(0);  //desplazamiento 
        const itemsPerPage = 10;   //número de elementos a mostrar
   
    //*useState
      const [swRecarga, setSwRecarga] =  useState(false);
      const [swRecargaPropuesta, setSwRecargaPropuesta] =  useState(false); //usado para remasterizar esta página
      const [cargandoSpin,setCargandoSpin] = useState(false);

      const [swPropuestaNva, setSwPropuestaNva] = useState(false);
      
      const [bandera,setBandera] = useState(false); //la uso para asegurarme que ya termino de leer Proposals/GetSummarybyUser/ por el regreso en el menu ya que si tenía abiertas las dejaba y estaba leyendo Proposals/GetDetailbyUserAll/

    //*useEffect

      useEffect(()=> { // al montar
        //console.log('Propuesta - monto');
        props.quitaErrorPagina();
        limpiaPropuestasStore();
        console.clear();
      },[]);

      useEffect(()=> { //Carga cátalogo "Origen del cambio"- llama API - Catalogs/GetAllOrigin/{lang}
        setCargandoSpin(true);
        catalogsServicio.cargaGetAllOrigin(props.tokenStore)
          .then((response:any) => {
              if (response.status==200) {  //revisa si hay error
                  guardaGetAllOriginStore(response.data).then( function(datos:any) { 
                     //console.log('cargamos información a catOriginesStore', datos );
                  })
              }    
              setCargandoSpin(false);
          })
          .catch((ex) => { 
              console.log ("--catch - ex (cargaGetAllOrigin): ", ex);
              generaObjErrorCatalogsStore(ex.response, true, '', '', 'Propuesta-Catalogs/GetAllOrigin','P');
              setCargandoSpin(false);
              recargaPaginaSSC();
          })
      },[]);
      
      useEffect(()=> { //Carga cátalogo "Procesos"- llama API - Catalogs/getAllProcessByFrequency/{lang}
        setCargandoSpin(true);
        catalogsServicio.cargaGetAllProcessByFrequency(props.tokenStore)
          .then((response:any) => {
              if (response.status==200) {   //revisa si hay error
                  guardaGetAllProcessByFrequencyStore(response.data).then( function(datos:any) { 
                    //console.log('cargamos información a catProcesosStore', datos );
                    setSwRecarga(!swRecarga)
                  })
              }
              setCargandoSpin(false);
          })
          .catch((ex) => {
              console.log ("--catch - ex (cargaGetAllProcessByFrequency): ", ex);
              generaObjErrorCatalogsStore(ex.response, true, '', '', 'Propuesta-Catalogs/GetAllProcessByFrequency','P');
              setCargandoSpin(false);
              recargaPaginaSSC();
          })
      },[]);

      useEffect(()=> { //Carga propuestas - llama API - Proposals/GetSummarybyUser
        setBandera(false)
        setCargandoSpin(true);
        proposalsServicio.cargaGetSummarybyUser(props.tokenStore)
          .then(function(response:any){
              if (response.status==200){  //revisa si hay error
                  guardaGetSummarybyUserStore(response.data).then( function(datos:any) { 
                    //const  data  = datos;
                    setBandera(true);
                  })
              }
              setCargandoSpin(false);
           })
          .catch((ex) => {
              console.log ("--catch - ex (cargaGetSummarybyUser): ", ex.response.status);
              if (ex.response.status==404) //no es error solo no tiene información
                  console.log('nota: no es error solo no tiene información')
              else{
                  generaObjErrorProposalsStore(ex.response, true, '', 'P', 'Propuesta-Proposals/GetSummarybyUser','P');
                  recargaPaginaSSC();
              }    
              setCargandoSpin(false);
          });
          setSwRecarga(!swRecarga)
      },[]);
    
      useEffect(()=> {   //usado para renderizar
          //console.log('Propuesta - renderizando .........................');
          //console.log('---propuestasStore:', propuestasStore);
          data=propuestasStore;
          setSwRecargaPropuesta(!swRecargaPropuesta);
      },[swRecarga]);

      useEffect(() => { //paginación: se ejectura al cambio de un elementos (al click en los botones)
       //console.log('entro a useEffect paginación')
        const endOffset = itemOffset + itemsPerPage;
        setCurrentItems(data.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(data.length / itemsPerPage));
        setSwRecarga(!swRecarga);
        //console.log('::data', data);
      }, [itemOffset, itemsPerPage, data]);
     
      useEffect(()=>{ //paginación: para subir la pantalla
         window.scrollTo({top:0});
      },[currentItems])

    //*funciones

      const recargaPaginaSSC = () => { props.recargaPaginaSSC() } //ejecuta la función que esta en Contenido que llama a la renderización de PaginaSSC
      const recargaPaginaSSC_Not = () => { props.recargaPaginaSSC_Not() } //ejecuta la función que esta en Contenido que llama de PaginaSSC recargar el api de notificaciones para la campana

      const recargaPropuesta = () => {  // con esto ejecuto un useEffect, lo uso para renderizar el front 
        //const data  = propuestasStore;
        setSwRecarga(!swRecarga);
      }
  
      const recargaPropuestaNva = (id:any) => {
        //console.log('recargaPropuestaNva....');
        //const data  = propuestasStore;
        setItemOffset(10);  //lo uso para generar un cambio para el useefect
        setItemOffset(0);  //lo regreso a la páginación inicial 
        setSwPropuestaNva(false); //reinicializo el objeto propuestaNvaStore
        setBandera(true);
        setSwRecarga(!swRecarga);
      }
      
      const abreCierraPropuesta = (idProp:any, swAbierto:any) => {  // abre y cierra el div de la propuesta
        //alert('abreCierraPropuesta...' + idProp+ '...' + swAbierto);
        cambiaPropuestasStore(idProp, !swAbierto, null, 'abreCierraPropuesta');
        setSwRecarga(!swRecarga);
      }

      const botonCierraPropuesta = (idProp:any) =>{
        //alert(":::botonCierraPropuesta - propuestasStore[0].id: "+ paso);
        if (idProp==0) { //propuesta nueva
            setSwPropuestaNva(false);// con esto reactivo los 4 useEffect  
        }
        else { //propuesta cargada
            cambiaPropuestasStore(idProp, false, null, 'botonCierraPropuesta');
        }
        setSwRecarga(!swRecarga);
      }
      
      const botonAgregarPropuestaDeCambio = () =>{
        let pasoCatO= JSON.parse(JSON.stringify(catOrigenesStore));
        let pasoCatP= JSON.parse(JSON.stringify(catProcesosStore));
        agregaPropuestaNvaStore(pasoCatO, pasoCatP);
        setSwRecargaPropuesta(!swRecarga);
        setSwPropuestaNva(true); //activa ventana con registro nuevo
      }

      const clickPaginacion = (event: any) => {  //paginación: se ejecuta cuando se da un click en los elementos de páginación (botones)
        const newOffset = (event.selected * itemsPerPage) % data.length;
        //console.log("newOffset--------", newOffset);
        setItemOffset(newOffset);
        setSwRecarga(!swRecarga) 
      };
     
    //*vista
      return(
       <>
          {/* nota de mensaje de error */}
            { (props.menuStore[0].errorPagina==true) &&
               (<> <label className='color-red'>Nota: se detecto un error al leer un recurso API, ¡algunos componentes pueden no funcionar correctamente!</label> </>)
            }

          {/* botón - Agregar propuesta de cambio */} 
            <div className="text-right">
                <button onClick={botonAgregarPropuestaDeCambio} className="btn btn-pill " id="bttAgr"> {eti.botones[0].text} </button>
            </div>
          
          {/* div - Agregar propuesta de cambio*/} 
            <div>
              {swPropuestaNva &&
                (<>
                    <div className="margin-1r">
                          <PropuestaContenido 
                            key={0}
                            tokenStore={props.tokenStore} 
                            propuestaNva={true}
                            idPropuesta={0} 
                            catOrigenesStore={catOrigenesStore}  
                            catProcesosStore={catProcesosStore}  
                            botonCierraPropuesta={botonCierraPropuesta} 
                            recargaPropuesta = {recargaPropuesta}
                            recargaPropuestaNva = {recargaPropuestaNva}
                            recargaPaginaSSC = {recargaPaginaSSC}
                            recargaPaginaSSC_Not  = {recargaPaginaSSC_Not }
                          /> 
                    </div>
                </>)
              }
            </div>

          {/* div's - Propuestas existentes */}  {/* defaultActiveKey={1}  se pone para abrir la primera siempre*/}
            <div>
              {/* {console.log('propuestasStore::::',propuestasStore)} 
                  {console.log('currentItems::::',currentItems)} este elemento tienen las lista de propuesta se usa para la paginación    */}               
              { currentItems?.map((p:any, index:any) => (
                (x0 =  `<span id='fechah'>&nbsp;${p.fecha}</span>&nbsp;
                        <span id='folioh'>Folio: ${p.folio} <span>&nbsp;&nbsp;`),
                (x1 =  `<span id="estatushV"> ${p.estatusTexto}</span>`),
                (x1a = `<span id="estatushN"> ${p.estatusTexto}</span>`),

                /*x2 forma el contendio del header del panel*/
                (x2 = (
                  <>
                    <div id={`divpanel_${p.id}`}>
                      {/* propuesta &  fecha */}
                      <span id="panelDes">
                        <span className="color-secundario panelDesPropuesta">{p.description}</span> 
                        <BsCalendarEvent size="14px" color="#707070" />
                      </span>

                      {/* folio */}
                      <span dangerouslySetInnerHTML={{ __html: x0, }} ></span>

                      {/* estatus */}
                      <span>
                        {p.estatusTexto === "Enviada" 
                          ? (<>
                              <BsEnvelope size="14px" color="#28A745" />
                              <span dangerouslySetInnerHTML={{ __html: x1 }} ></span>
                            </>) 
                          : (<>
                              <BsEnvelope size="14px" color="#fd7e14" />
                              <span dangerouslySetInnerHTML={{ __html: x1a }} ></span>
                            </>)
                        }
                      </span>
                    </div>
                  </>
                )),
                (<>
                  {p.eliminado==false  && //antes de enviar el usuario puede eliminar un registro guardado, en el front la baja es virtual en el arreglo de movimiento
                    (<>
                      <hr />
                      <PanelGroup accordion  >
                        <Panel
                          header={x2}
                          /* eventKey={index} usado cuando se quiere un solo panel abierto */
                          key={p.key}
                          id={p.id}
                          collapsible={p.abierto}
                          onClick={() => abreCierraPropuesta(p.id, p.abierto)}
                        >
                        </Panel>
                            {bandera  && //la uso para asegurarme que ya termino de leer Proposals/GetSummarybyUser/ por el regreso en el menu
                             (<>
                                {p.abierto &&
                                   (<PropuestaContenido
                                        key={p.id}
                                        tokenStore={props.tokenStore}
                                        propuestaNva={false} 
                                        idPropuesta={p.id} 
                                        catOrigenesStore={catOrigenesStore}  
                                        catProcesosStore={catProcesosStore}  
                                        //propuestaDetalles={p.propuestaDetalles} 
                                        botonCierraPropuesta={botonCierraPropuesta} 
                                        recargaPropuesta = {recargaPropuesta}
                                        recargaPropuestaNva = {recargaPropuestaNva}
                                        recargaPaginaSSC = {recargaPaginaSSC}
                                        recargaPaginaSSC_Not  = {recargaPaginaSSC_Not }
                                   />)
                                }
                              </>)
                            }
                        </PanelGroup> 
                    </>)
                  }
                </>)
              ))}
            </div>

          <hr/><br/>

           {/* paginación: elemento visuales  */}
            { pageCount > 1 &&
              (<>
                  <ReactPaginate
                    //2.1
                    breakClassName="..."
                    nextLabel={
                    <AiOutlineDoubleRight  style={{ fontSize: 18, width: 150, verticalAlign: "middle", marginLeft: "-10px",}} />
                    }          
                    pageRangeDisplayed={2}
                    pageCount={pageCount}
                    previousLabel={
                      <AiOutlineDoubleLeft style={{ fontSize: 18, width: 150, verticalAlign: "middle",  marginLeft: "10px", }} />
                    }
                    renderOnZeroPageCount={null}
                    containerClassName="pagination"
                    pageLinkClassName="page-num"
                    previousLinkClassName="page-num"
                    nextLinkClassName="page-num"
                    activeClassName="active"
                    disabledLinkClassName="gray"
                    onPageChange={clickPaginacion}
                    // onClick={clickPaginacion}
                  />
              </>) 
            }

          {/* ventana de carga con spin que se abre mientras lee el api */}
            { cargandoSpin && <CargandoSpin /> }

       </>
      )
  }

  {/*  dangerouslySetInnerHTML={{__html: eti[4].text}} */}